import React from 'react'

export default function About() {
    return (
        <div className="section">
            <h2 className="section--heading">About</h2>
            <p className="section--content">I am a student who is studying to be a website developer. Passionate about full stack website development and mobile applications, I work hard to create solutions to the problems I see.</p>
        </div>
    )
}